import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

export const Form = styled.div`
    display: flex;
    flex-direction: column;

    width: 100%;
    min-height: 228px;
    padding: 24px 24px 0;
`;

export const formModalStyles = css`
    & .ant-modal-footer {
        background: ${Colors.Gray.V50};
        border: none;
    }

    & .ant-modal-content {
        overflow: visible;
    }
`;

export const formModalStyleMinHeight = (minHeight: number): string => css`
    & .ant-modal-content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: ${minHeight}px;
    }
`;
